import { RGBAArray } from "ramper"

// NOTE: changing classname value requires changes in purgecss config
export const NON_TRUSTED_STYLE = {
    classname: "grape-500",
    lighterRGB: [179, 149, 231],
    darkerRGB: [118, 56, 225]
}

// NOTE: changing classname value requires changes in purgecss config
export const TRUSTED_STYLE = {
    classname: "black",
    lighterRGB: [104, 106, 112],
    darkerRGB: [0, 0, 0]
}

// NOTE: changing classname value requires changes in purgecss config
export const ACTIVE_STYLE = {
    classname: "blue-500",
    lighterRGB: [98, 167, 255],
    darkerRGB: [47, 128, 237]
}

export enum BoundingBoxStatus {
    NON_TRUSTED = "NON_TRUSTED",
    TRUSTED = "TRUSTED",
    ACTIVE = "ACTIVE"
}

export const BoundingBoxStatusStyles = {
    [BoundingBoxStatus.NON_TRUSTED]: {
        bgColor: [...NON_TRUSTED_STYLE.lighterRGB, 50] as RGBAArray,
        borderWidth: 3,
        borderStyle: [...NON_TRUSTED_STYLE.lighterRGB, 255] as RGBAArray,
        showSize: false,
        lineDash: [8, 10],
        radii: 5,
        bgColorSelected: [...NON_TRUSTED_STYLE.darkerRGB, 50] as RGBAArray,
        borderStyleSelected: [...NON_TRUSTED_STYLE.darkerRGB, 255] as RGBAArray
    },
    [BoundingBoxStatus.TRUSTED]: {
        bgColor: [...TRUSTED_STYLE.lighterRGB, 50] as RGBAArray,
        borderWidth: 3,
        borderStyle: [...TRUSTED_STYLE.lighterRGB, 255] as RGBAArray,
        showSize: false,
        radii: 5,
        bgColorSelected: [...TRUSTED_STYLE.darkerRGB, 50] as RGBAArray,
        borderStyleSelected: [...TRUSTED_STYLE.darkerRGB, 255] as RGBAArray
    },
    [BoundingBoxStatus.ACTIVE]: {
        bgColor: [...ACTIVE_STYLE.lighterRGB, 50] as RGBAArray,
        borderWidth: 3,
        borderStyle: [...ACTIVE_STYLE.lighterRGB, 255] as RGBAArray,
        showSize: false,
        lineDash: [8, 10],
        radii: 5,
        bgColorSelected: [...ACTIVE_STYLE.darkerRGB, 50] as RGBAArray,
        borderStyleSelected: [...ACTIVE_STYLE.darkerRGB, 255] as RGBAArray
    }
}

export const DEFAULT_SCHEMA = {
    schema: {},
    uiSchema: {
        "ui:field": "https://widgets.super.ai/document-extraction@1"
    }
}
